import { post, get, baseURL } from "@/utils/request";

export const getUserRankDailyCheckin = () => get(`/activity/userRankDailyCheckIn`);